/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShieldPlus = createReactComponent("shield-plus", "IconShieldPlus", [
  [
    "path",
    {
      d: "M12.462 20.87c-.153 .047 -.307 .09 -.462 .13a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .11 6.37",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 19h6", key: "svg-1" }],
  ["path", { d: "M19 16v6", key: "svg-2" }]
]);

export { IconShieldPlus as default };
//# sourceMappingURL=IconShieldPlus.js.map
